import styled from 'styled-components';

const FileInputAdsCustom = styled.div`
  width: 100%;
  .RaFileInput-dropZone {
    padding: 12px 16px !important;
    .MuiSvgIcon-root {
      font-size: 28px !important;
      margin-bottom: 6px !important;
    }
    p {
      font-size: 13px;
      margin: 6px 0;
    }
  }
`;

export default FileInputAdsCustom;

